import { jitsuAnalytics } from "@jitsu/js";

export function identifyUser(user) {
  const analytics = jitsuAnalytics({
    host: "https://clvmgwbsa00003b6tzgc1lib2.d.jitsu.com",
  });
  analytics.identify(user.sub, user);
  analytics.group("rda");
}
